export const sectionMapper = {
  introSection: "Intro",
  understandingSection: "Our Understanding",
  valuePropositionSection: "Elixirr Value Proposition",
  ourApproachSection: "Our Proposed Approach",
  teamSection: "Team & Commercials",
  caseStudiesSection: "Case Studies",
};

export const dynamicSections = [
  "introSection",
  "understandingSection",
  "ourApproachSection",
  "teamSection",
  "caseStudiesSection",
];
